import React from 'react'
import get from 'lodash/get'
import { CloudDownloadOutlined, TabOutlined } from '@material-ui/icons'
import { checkIfEditionIsDeleted } from '../../services/pack'
import { Space } from '../../layouts'
import { P } from '../StyledText'
import { DownloadFileLink } from '../DownloadFileLink'
import { StyledTitle, TitleWrapper } from './styled'

export const EditionLevelSourceFile = ({ edition, isDataSteamGraphics }) => {
  const disableDownload = checkIfEditionIsDeleted(edition)
  return (
    <Space mb={4}>
      <TitleWrapper>
        <StyledTitle mb={2}>
          Source file <span>Image</span>
        </StyledTitle>
        {isDataSteamGraphics ? (
          <a
            title="Source file"
            href={get(edition, 'dataStreamGraphic.dataStreamURI')}
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            <TabOutlined color="primary" />
          </a>
        ) : (
          get(edition, 'file.fileId') && (
            <DownloadFileLink
              fileId={edition.file.fileId}
              disabled={disableDownload}
            >
              <CloudDownloadOutlined
                color={disableDownload ? 'disabled' : 'primary'}
              />
            </DownloadFileLink>
          )
        )}
      </TitleWrapper>
      <article className="source">
        <P>{edition.editionName}</P>
      </article>
    </Space>
  )
}
